import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import Link from 'next/link'
import { ModalStore } from '../../state/ModalStore'
import GeneralModal from '../Modals/GeneralModal'
import YoutubeEmbed from '../YoutubeEmbed'
import { PlayIcon } from '@heroicons/react/solid'

dayjs.extend(relativeTime)

const channelLogos = {
    Spotify: '/assets/podcasts/platforms/spotify.svg',
    Apple: '/assets/podcasts/platforms/apple.svg',
    Google: '/assets/podcasts/platforms/google.svg',
}

const PodcastDetails = ({ podcast, tags }) => {
    const addModal = ModalStore((state) => state.add)

    const handleVideo = () => {
        addModal(
            <GeneralModal>
                <YoutubeEmbed
                    autoPlay={true}
                    cssClass={'rounded-xl w-full'}
                    url={podcast?.acf?.youtube_url}
                />
            </GeneralModal>,
        )
    }

    return (
        <div className="md:w-new-header md:mx-auto mx-6 max-w-full">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0 md:space-x-8">
                {/* Left section - Image */}
                <div className="md:flex-shrink-0 w-full md:w-3/12">
                    <div className="relative">
                        <img
                            src={
                                podcast?.thumbnail?.url ||
                                'https://via.placeholder.com/390x396?text=No+Image+Available'
                            }
                            alt={podcast?.title?.rendered || 'Placeholder'}
                            className="rounded-lg shadow-lg w-full h-auto"
                        />
                        <button
                            onClick={handleVideo}
                            className="absolute bg-olm-black bottom-4 left-4 text-white rounded-full px-2 p-1 text-sm flex items-center">
                            <PlayIcon className="h-10 w-10 text-olm " />
                            <span className="ml-1">Start Listening</span>
                        </button>
                    </div>
                </div>

                {/* Right section - Details */}
                <div className="flex-grow space-y-4">
                    {/* Tags */}
                    <div className="space-x-2">
                        {tags.map((tag, idx) => (
                            <Link key={idx} href={`/podcasts/tag/${tag.slug}`}>
                                <a className="text-orange-500 uppercase font-bold">
                                    #{tag.name}
                                </a>
                            </Link>
                        ))}
                    </div>

                    {/* Title */}
                    <h1 className="text-3xl md:text-5xl font-bold text-gray-800">
                        {podcast?.title?.rendered}
                    </h1>

                    {/* Episode details */}
                    <p className="text-gray-400 text-sm space-x-4">
                        <span>
                            Episode {podcast?.acf?.episode_details?.number}
                        </span>
                        <span>&#124;</span>{' '}
                        <span>By {podcast?.acf?.episode_details?.by}</span>
                        <span>&#124;</span>
                        <span>
                            {podcast.date && dayjs(podcast.date).fromNow()}
                        </span>
                    </p>

                    {/* Podcast links */}
                    {podcast?.acf?.episode_details?.links && (
                        <div className="flex flex-wrap md:space-x-2 py-4 space-x-1 sm:space-x-4 mt-4">
                            {podcast?.acf?.episode_details?.links.map(
                                (link, idx) => (
                                    <a
                                        target="_blank"
                                        href={link.link}
                                        key={idx}
                                        className="rounded-2xl px-3 py-2 sm:px-4 sm:py-2 border mb-2"
                                        rel="noreferrer">
                                        <img
                                            src={channelLogos[link.type]}
                                            alt={link.type}
                                            className="h-6"
                                        />
                                    </a>
                                ),
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PodcastDetails
